// extracted by mini-css-extract-plugin
module.exports = {"coinButton":"_80rAPj","headerBtn":"Txxc3E"};